import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, number } from 'prop-types'

import { useIs3dPrintModel } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'

import modelIcon from 'images/icons/svg/new_item_page/model-icon.svg'

function HeaderSection({ href, numberOfModels }) {
  const is3dPrintModel = useIs3dPrintModel()
  return (
    <div className="collection-models-area__header">
      <h2 className="collection-models-area__header-title">
        {is3dPrintModel ? '3D PRINT MODELS IN THIS PACK' : '3D MODELS IN THIS PACK'}
      </h2>
      <div className="collection-models-area__right-header-side">
        <div className="collection-models-area__header-count">
          <img src={modelIcon} alt="Model icon" className="collection-models-area__header-count-icon" />
          <span>{numberOfModels}</span>
        </div>
        <Button
          href={href}
          type="ghost"
          size="small"
          customClass="collection-models-area__header-button"
          aria-label="View all items in this pack"
        >
          View all
        </Button>
      </div>
    </div>
  )
}

HeaderSection.propTypes = {
  href: string.isRequired,
  numberOfModels: number.isRequired,
}

export default HeaderSection
